module.exports = __webpack_public_path__ + "img/img40.d00f24b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img40.jpg
// module id = 339
// module chunks = 0